module.exports = __webpack_public_path__ + "img/1.a553ff97.jpg";